// export var firebaseConfig = {
//     apiKey: 'AIzaSyBoUdiDtzQdC-m4nj9CPY5SvY7uKJGL71k',
//     authDomain: 'matx-15ede.firebaseapp.com',
//     databaseURL: 'https://matx-15ede.firebaseio.com',
//     projectId: 'matx-15ede',
//     storageBucket: 'matx-15ede.appspot.com',
//     messagingSenderId: '348111707030',
//     appId: '1:348111707030:web:70c4ca4eb3f1dbd18e1bb7',
//     measurementId: 'G-806629YLNN',
// };


export var firebaseConfig = {
    apiKey: "AIzaSyDVVm7I3QkuHSBTyLkVDJFvzVvAGfN0nJ0",
    authDomain: "testapp-23bb5.firebaseapp.com",
    databaseURL: "https://testapp-23bb5-default-rtdb.firebaseio.com",
    projectId: "testapp-23bb5",
    storageBucket: "testapp-23bb5.appspot.com",
    messagingSenderId: "15979636071",
    appId: "1:15979636071:web:2b6b17b3bcee9556bcbbc2"
};


export const auth0Config = {
    client_id: 'XmminWIs0S8gR3gIRBydYLWbF58x81vK',
    domain: 'matx.us.auth0.com',
}

export const serverCRMConfig = {
  apiKey:"03478f08258a5b0e7f4a1e83dae33da9",
  APIURL:"https://api.pixelcrm.ru",
};
